// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-8d2b108a] path[data-v-8d8486b0]{fill:#1c0152!important}", ""]);
// Exports
module.exports = exports;
